<template>
<div style="height: 40px; display: flex; align-items: center; justify-content: flex-start;">
    <div>
        <el-button class="button-car" @click="onShoppingCarClick">{{ $t("ShopObject.settlement") }}</el-button>
    </div>  
    <div class="shopping-car" :class="[sharkFlag ?'my-shark' :'']" id="myShark" @click="onShoppingCarClick"> 
          <span><i class="el-icon-shopping-cart-full" style="font-size: 32px;"></i></span>
          <span style="font-size: 20px; font-weight: bold;">{{ cartGoods.length }}</span>
      </div>
  </div>
</template>

<script>

import * as  shoppingCartStore from '@/store/shoppingcart.js'
    export default {
        name:'ShoppingCart',
        data(){
            return {
                cartGoods:[],
                sharkFlag:false,
                isReload:false
            }
        },
        mounted(){
            
            this.cleanShoppingCart()
            this.getShopCartInfo()
            this.$bus.$on('RELOAD_SHOPPINGCART_DATA',this.onReload)
            this.$bus.$on('LOGIN_STATE_CHANGED',this.onReload)
            
            const sharkDiv = document.getElementById("myShark");
            sharkDiv.addEventListener("animationend", this.stopShark);
        },
        beforeDestroy(){
            this.$bus.$off('RELOAD_SHOPPINGCART_DATA')
            this.$bus.$off('LOGIN_STATE_CHANGED')
        },
        methods:{
            stopShark(){
                this.sharkFlag = false
            },
            // 清空购物车数据
            cleanShoppingCart(){
                this.cartGoods = []
                shoppingCartStore.saveShoppingCart(this.cartGoods)
            },
            onShoppingCarClick(){
                let userInfo = this.$store.state.userInfo
                // console.log('shoppingcart userinfo',userInfo)
                // if(userInfo == undefined || userInfo.id == undefined){
                //     this.$alert(this.$t('LoginCommon.unloginTip'), this.$t('LoginCommon.unlogin'), {
                //         confirmButtonText: this.$t('LoginCommon.tologin'),
                //         confirmButtonClass: 'confirm-button-class',
                //         type:'warning',
                //         callback: action => {
                //             if(action == 'confirm'){
                //                 this.$bus.$emit('OPEN_LOGIN_DIALOG')
                //             }
                //         }
                //     });
                //     return
                // }
                let _that = this
                this.getShopCartInfo(function(code){
                    if(code == 200){
                        _that.$router.push({name:'shoppingcar'}).catch(function(err) {})
                    }
                })
                // console.log('跳转购物车。。。',this.$router)
            },
            getShopCartInfo(callback){
                let _that = this
                let ranId = ''
                let userInfo = this.$store.state.userInfo
                if(userInfo == undefined){
                    ranId = localStorage.getItem("UNLOGIN_USER_AUTO_RANID")
                    
                }else {
                    ranId = userInfo.ranId
                }

                // 兼容无账号购物
                this.$request.get('/shop/api/listCartByRanId' , {ranId:ranId}).then(function(response){
                    if (response.data.code == 200) {
                        _that.cartGoods = response.data.rows
                        shoppingCartStore.saveShoppingCart(_that.cartGoods)
                        _that.sharkFlag = _that.isReload;
                        _that.isReload = false
                    }
                    if(callback != undefined){
                        callback(response.data.code)
                    }
                }).catch(function(err){
                    if(callback != undefined){
                        callback(501)
                    }
                    
                })
            },
            onReload(){
                this.isReload = true
                this.getShopCartInfo()
            }
        }
    }
</script>

<style scoped>
    .shopping-car{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        margin-left: 4px;
        margin-right: 20px;
        color:#333333;
    }
    .button-car{
        width: 120px; 
        height: 40px; 
        background-color: #FF5D38; 
        color: white;
    }
    .my-shark{
        color:#FF5D38;
        animation: btn-shake 0.8s 1 ease-in;
    }
    @keyframes btn-shake {
        0% {transform: scale(1);}
        10%, 20% {transform: scale(0.9) rotate(-8deg);}
        30%, 50%, 70%, 90% {transform: scale(1.1) rotate(8deg);}
        40%, 60%, 80% {transform: scale(1.1) rotate(-8deg);}
        100% {transform: scale(1) rotate(0);}
    }
</style>



// WEBPACK FOOTER //
// src/components/common/shoppingcart.vue